// src/common/components/share/hooks/useShare.ts
import { useState } from 'react'
import {
  CargoItemInterface,
  SharePayload,
  SlotItemInterface,
  TransportItemInterface,
  ExecutorInterface,
} from '../../../types/interfaces'
import { ChatScreens, Group, NotificationTypes } from '../../../types/enums'
import {
  baseUrl,
  CARGO_ITEM_ROUTE,
  SLOT_ITEM_ROUTE,
  TRANSPORT_ITEM_ROUTE,
} from '../../../utils/constants'
import { useDispatch, useSelector } from 'react-redux'
import {
  selectChatModalActive,
  selectChatScreen,
  setChatModalState,
  setChatScreen,
  setSharePayload,
} from '../../../../store/slices/chatSlice'
import { addNotification } from '../../../../store/slices/notificationSlice'
import { v4 } from 'uuid'

export const useShare = (
  order?: SlotItemInterface | TransportItemInterface | CargoItemInterface,
  executor?: ExecutorInterface,
) => {
  const [modalActive, setModalActive] = useState(false)
  const dispatch = useDispatch()
  const chatActive = useSelector(selectChatModalActive)
  const chatScreen = useSelector(selectChatScreen)

  const generateLinkAndText = () => {
    if (executor) {
      if (!executor.inviteUuid) {
        return {
          text: `Ошибка: у исполнителя ${executor.name} нет invite-ссылки`,
          url: baseUrl + '/',
        }
      }
      return {
        text: `Приглашение исполнителя ${executor.name}`,
        url: `https://${process.env.REACT_APP_BASE_DOMAIN}?invite=${executor.inviteUuid}`,
      }
    }

    switch (order?.group) {
      case Group.SLOT:
        return {
          text: `Ссылка на слот #${order.id} в сервисе logid`,
          url: `${baseUrl + SLOT_ITEM_ROUTE}/${order?.id}`,
        }
      case Group.CARGO:
        return {
          text: `Ссылка на слот #${order.id} в сервисе logid`,
          url: `${baseUrl + CARGO_ITEM_ROUTE}/${order?.id}`,
        }

      case Group.TRANSPORT:
        return {
          text: `Ссылка на транспорт #${order.id} в сервисе logid`,
          url: `${baseUrl + TRANSPORT_ITEM_ROUTE}/${order?.id}`,
        }

      default:
        return {
          text: `Ссылка на сервис logid`,
          url: baseUrl + '/',
        }
    }
  }

  const chatShareAction = (payload: SharePayload) => {
    dispatch(setSharePayload(payload))
    if (!chatActive) dispatch(setChatModalState(true))
    if (chatScreen !== ChatScreens.LIST) dispatch(setChatScreen(ChatScreens.LIST))
    dispatch(
      addNotification({
        id: v4(),
        type: NotificationTypes.SUCCESS,
        text: 'Кликните на тему в чате, чтобы поделиться',
      }),
    )
    setModalActive(false)
  }

  return { modalActive, setModalActive, generateLinkAndText, chatShareAction }
}
